import { defineStore } from 'pinia'

export const SP_Start = defineStore('sch_s_period_start', {
    state: () => {
        return { sch_s_period_start: null }
    },
    actions: {
        get() {
            return this.sch_s_period_start
        },
        set(data) {
            this.sch_s_period_start = data
        }
    },
})

export const SP_User = defineStore('sch_s_user', {
    state: () => {
        return { sch_s_user: null }
    },
    actions: {
        get() {
            return this.sch_s_user
        },
        set(data) {
            this.sch_s_user = data
        }
    },
})
export const SP_Drawer_status = defineStore('sch_d_flag', {
    state: () => {
        return { sch_d_flag: false }
    },
    actions: {
        get() {
            return this.sch_d_flag
        },
        set(data) {
            this.sch_d_flag = data
        }
    },
})


export const SP_Drawer_user = defineStore('sch_d_user', {
    state: () => {
        return { sch_d_user: null }
    },
    actions: {
        get() {
            return this.sch_d_user
        },
        set(data) {
            this.sch_d_user = data
        }
    },
})

export const SP_End = defineStore('sch_s_period_end', {
    state: () => {
        return { sch_s_period_end: null }
    },
    actions: {
        get() {
            return this.sch_s_period_end
        },
        set(data) {
            this.sch_s_period_end = data
        }
    },
})